import * as React from "react";
import type { SVGProps } from "react";
const SvgShieldCheck = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m9.6 11.188 1.8 1.8 3.6-3.6m-10.2-3.6 5.59-2.795a3.6 3.6 0 0 1 3.22 0l5.59 2.795v8.028c0 2.771-2.562 4.643-7.2 7.571-4.638-2.928-7.2-5.4-7.2-7.571z"
    />
  </svg>
);
export default SvgShieldCheck;
